module.exports = "pegasus_template/assets/theme5/medium/2.jpg";